// src/components/RoleBasedRender.jsx
import React from 'react';
import AuthService from '../services/AuthService';

const RoleBasedRender = ({ roles, children }) => {
    const currentUser = AuthService.getCurrentUser();
    const userRoles = currentUser?.roleNames || [];

    // Vérifie si l'utilisateur a au moins un des rôles spécifiés
    const hasRequiredRole = roles.some(role => userRoles.includes(role));

    return hasRequiredRole ? <>{children}</> : null;
};

export default RoleBasedRender;